<ng-container *ngIf="control; else skeleton">

<dk-ctl-sablon #sablonCmp [id]="'container-'+ controlName"
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode"
    [title]="title" [code]="code" [validationRules]="validationRulesMap" [validationV2]="validationV2"
    (handleValueChange)="handleValueChange($event)" [isShowMap]="isShowMap" (showMap)="showMapClick($event)"
    (searchClick)="searchClick()" (codeChanges)="code = $event" [codeAreaWidth]="codeAreaWidth" [warningMessage]="warningMessage"
    (clear)="clear()" [autoFocusOn]="autoFocusOn" [tabIndex]="tabIndex">
</dk-ctl-sablon>
<dx-popup *ngIf="crudPopupVisible && control"
    [title]="control.controlDescription + ' Arama (' + controlName + ')'"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [width]="width"
    [height]="height"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
  <dk-ctl-gen-kontrol-arama
    [key]="key"
    [selectMode]="selectMode"
    [control]="control"
    [controlName]="controlName"
    [filterColumn]="filterColumn"
    [customSearchShow]="customSearchShow"
    [customSearchInfo]="customSearchInfo"
    [filterColumnValue]="filterColumnValue"
    [aramaFiltresi]="aramaFiltresi"
    (changeControl)="changeControl($event)"
    (closePopup)="closePopupAfter($event, sablonCmp)"
  ></dk-ctl-gen-kontrol-arama>
</dx-popup>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>